import './ProgressBannerStyle.less';

import { ImgixImg } from '@opendoor/bricks';
import * as React from 'react';

interface IProps {
  progress: string;
  ctaText: string;
  shouldDisplayCta: boolean;
  onCtaClick: () => void;
  renderBannerFn: () => void;
}

class ProgressBanner extends React.Component<IProps> {
  public render() {
    const { renderBannerFn } = this.props;
    return (
      <div className="row od-progress-banner-background">
        <div className="progress-banner">
          {this.renderProgress()}
          {renderBannerFn()}
        </div>
        {this.renderCTA()}
      </div>
    );
  }

  private renderCTA = () => {
    const { ctaText, onCtaClick, shouldDisplayCta } = this.props;
    if (shouldDisplayCta) {
      return (
        <div className="progress-banner-button-container">
          <button className="progress-banner-button button transparent" onClick={onCtaClick}>
            {ctaText}
          </button>
        </div>
      );
    }
    return null;
  };

  private renderProgress = () => {
    const { progress } = this.props;
    const progressSize = 60;
    const progressRadius = progressSize / 2.0;
    const progressInnerRadius = progressRadius - 3.0;

    return (
      <div className="od-progress">
        <div className="progress-banner-status-container">
          <ImgixImg
            src="476e77b0c6004d3b94b69465e2fb4005.svg"
            className="progress-banner-status-icon"
          />
        </div>
        <svg className="progress-background" viewBox={`0 0 ${progressSize} ${progressSize}`}>
          <circle
            className="progress-meter"
            cx={`${progressRadius}`}
            cy={`${progressRadius}`}
            r={`${progressInnerRadius}`}
          />
          <circle
            className={`progress-value ${progress}`}
            cx={`${progressRadius}`}
            cy={`${progressRadius}`}
            r={`${progressInnerRadius}`}
          />
        </svg>
      </div>
    );
  };
}

export default ProgressBanner;
